import { BlogAnchor } from "./BlogAnchor";

/** `<CategoryLink slug label />`: inline link to /category/{slug}. Tracked inside BlogAnchor. */
export function CategoryLink({ slug, label }: { slug: string; label: string }) {
  return <BlogAnchor href={`/category/${encodeURIComponent(slug)}`}>{label}</BlogAnchor>;
}

export default CategoryLink;
